import {enableProdMode, importProvidersFrom} from '@angular/core';
import '@angular/common/locales/global/de';
import '@angular/common/locales/global/en-GB';
import {environment} from './environments/environment';
import {provideTranslateService} from '@ngx-translate/core';
import {ApiModule} from './app/api/api.module';
import {API_URL_PLACEHOLDER} from './app/constants/api-url-placeholder.constant';
import {API_CONFIGS} from './configs/api.config';
import {ApiModule as BfaApiModule} from './app/bfa-api/api.module';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {DEFAULT_PROVIDERS} from './app/providers/default-providers';
import {SENTRY_PROVIDERS} from './app/providers/sentry-providers';
import {Capacitor} from '@capacitor/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {MSAL_PROVIDERS} from './app/providers/msal-providers';
import {ElectronService} from './app/services/electron/electron.service';
import {AppStorageIdEnum} from './app/enums/app-storage-id.enum';
import {SentryService} from './app/services/sentry/sentry.service';
import {IPC_APP_BOOTSTRAP_FAILED} from './app/constants/shared.constants';
import {AmagnoStorageKeyEnum} from './app/enums/amagno-storage-key.enum';

if (environment.production) {
    enableProdMode();
}

let providers = [
    importProvidersFrom(
        ApiModule.forRoot({ rootUrl: API_URL_PLACEHOLDER + '/' + API_CONFIGS.apis.internal.path }),
        BfaApiModule.forRoot({ rootUrl: API_URL_PLACEHOLDER + '/' + API_CONFIGS.apis.bfa.path }),
    ),
    provideTranslateService({
        loader: provideTranslateHttpLoader({
            prefix: '/assets/i18n/',
            suffix: '.json',
        }),
    }),
    DEFAULT_PROVIDERS
];

if (environment.sentry) {
    providers = [
        ...providers,
        SENTRY_PROVIDERS
    ];
}

if (!Capacitor.isNativePlatform() && !ElectronService.isElectronApp()) {
    providers = [
        ...providers,
        MSAL_PROVIDERS
    ];
}

// Temporary code to migrate the legacy lowercase storage keys to new uppercase storage keys
try {
    const amagnoStore = window.localStorage.getItem(AppStorageIdEnum.AMAGNO);

    if (amagnoStore) {
        const amagnoStoreData = JSON.parse(amagnoStore);
        const currentUppercaseStorageKeys = Object.keys(AmagnoStorageKeyEnum);
        const lowercaseKeysInStorage = currentUppercaseStorageKeys
            .filter(currentUppercaseStorageKey => amagnoStoreData[currentUppercaseStorageKey.toLowerCase()])
            .map(item => item.toLowerCase());

        if (lowercaseKeysInStorage) {
            lowercaseKeysInStorage.forEach(lowercaseKey => {
                amagnoStoreData[lowercaseKey.toUpperCase()] = amagnoStoreData[lowercaseKey];
            });

            window.localStorage.setItem(AppStorageIdEnum.AMAGNO, JSON.stringify(amagnoStoreData));

            lowercaseKeysInStorage.forEach(lowercaseKey => {
                delete amagnoStoreData[lowercaseKey];
            });

            window.localStorage.setItem(AppStorageIdEnum.AMAGNO, JSON.stringify(amagnoStoreData));
        }
    }
} catch (error) {
    console.error('Migrating the legacy lowercase storage keys failed', error);
}

bootstrapApplication(AppComponent, {
    providers: [...providers]
})
    .then(appRef => appRef.injector.get(SentryService)
        .initSentryCapacitor())
    .catch(err => {
        console.error(err);
        ElectronService.ipcRender?.send(IPC_APP_BOOTSTRAP_FAILED, err instanceof Error ? err.stack ?? err.message : String(err));
    });
